/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NaturalLanguageAnalyzeEntitiesSuccessResponseData,
    NaturalLanguageAnalyzeEntitiesSuccessResponseDataFromJSON,
    NaturalLanguageAnalyzeEntitiesSuccessResponseDataFromJSONTyped,
    NaturalLanguageAnalyzeEntitiesSuccessResponseDataToJSON,
} from './NaturalLanguageAnalyzeEntitiesSuccessResponseData';

/**
 * POST /natural_language/analyze_entities
 * @export
 * @interface NaturalLanguageAnalyzeEntitiesResponse
 */
export interface NaturalLanguageAnalyzeEntitiesResponse {
    /**
     * 
     * @type {number}
     * @memberof NaturalLanguageAnalyzeEntitiesResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof NaturalLanguageAnalyzeEntitiesResponse
     */
    message: string;
    /**
     * 
     * @type {NaturalLanguageAnalyzeEntitiesSuccessResponseData}
     * @memberof NaturalLanguageAnalyzeEntitiesResponse
     */
    data: NaturalLanguageAnalyzeEntitiesSuccessResponseData;
}

export function NaturalLanguageAnalyzeEntitiesResponseFromJSON(json: any): NaturalLanguageAnalyzeEntitiesResponse {
    return NaturalLanguageAnalyzeEntitiesResponseFromJSONTyped(json, false);
}

export function NaturalLanguageAnalyzeEntitiesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NaturalLanguageAnalyzeEntitiesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': NaturalLanguageAnalyzeEntitiesSuccessResponseDataFromJSON(json['data']),
    };
}

export function NaturalLanguageAnalyzeEntitiesResponseToJSON(value?: NaturalLanguageAnalyzeEntitiesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': NaturalLanguageAnalyzeEntitiesSuccessResponseDataToJSON(value.data),
    };
}

